import React from "react";
import { Box, Typography } from "@mui/material";
import ExplicitIcon from "@mui/icons-material/Explicit";
import { useTranslation } from "react-i18next";

export default function ExplicitBadge({ show, size = "small" }) {
  const { t } = useTranslation("common");
  const isExplicit = show === true || show === "true" || show === 1 || show === "1";
  if (!isExplicit) return null;
  const label = t("explicitTag", { defaultValue: "Explicit" });
  const iconSize = size === "large" ? 18 : 14;

  return (
    <Box
      className="explicit-badge"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        padding: "2px 6px",
        borderRadius: "8px",
        border: "1px solid rgba(255, 255, 255, 0.35)",
        backgroundColor: "rgba(255, 255, 255, 0.12)",
        color: "#f06292",
        lineHeight: 1,
        textTransform: "uppercase",
        height: size === "large" ? 26 : 22,
      }}
    >
      <ExplicitIcon sx={{ fontSize: iconSize }} />
      <Typography variant="caption" sx={{ fontWeight: 700, color: "inherit" }}>
        {label}
      </Typography>
    </Box>
  );
}
